if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {

      // ─── Lifecycle ───────────────────────────────────────────────

      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template')
          .content.firstElementChild.cloneNode(true);

        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        if (this.querySelector('[data-liquid-rendered]')) {
          // Liquid already rendered first paint —
          // silently fetch and attach the drawer so aria-controls wires up
          this.fetchDrawerOnly(this.dataset.variantId);
        } else {
          this.fetchAvailability(this.dataset.variantId);
        }
      }

      // ─── Public API (called by variant picker) ───────────────────

      update(variant) {
        if (variant?.available) {
          const liquidRendered = this.querySelector('[data-liquid-rendered]');
          if (liquidRendered) liquidRendered.removeAttribute('data-liquid-rendered');

          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      // ─── Fetch helpers ───────────────────────────────────────────

      buildUrl(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) rootUrl = rootUrl + '/';
        return `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
      }

      fetchAvailability(variantId) {
        fetch(this.buildUrl(variantId))
          .then((response) => response.text())
          .then((text) => {
            const section = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

            this.renderPreview(section);
          })
          .catch(() => {
            if (this.hasAttribute('available')) {
              const button = this.querySelector('button');
              if (button) button.removeEventListener('click', this.onClickRefreshList);
              this.renderError();
            }
          });
      }

      fetchDrawerOnly(variantId) {
        // Silently fetches and attaches only the drawer —
        // BasicModal's own listeners will wire the aria-controls button automatically
        fetch(this.buildUrl(variantId))
          .then((response) => response.text())
          .then((text) => {
            const section = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

            this.attachDrawer(section);
          })
          .catch(() => {});
      }

      // ─── Render ──────────────────────────────────────────────────

      renderPreview(section) {
        this.removeDrawer();

        const freshPreview = section?.querySelector('pickup-availability-preview');

        if (!freshPreview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        // Compare available store count — skip DOM update if stock unchanged
        const liquidRendered = this.querySelector('[data-liquid-rendered]');
        if (liquidRendered) {
          const liquidCount = liquidRendered.querySelectorAll('.is-available').length;
          const freshCount = freshPreview.querySelectorAll('.is-available').length;

          if (liquidCount === freshCount) {
            this.attachDrawer(section);
            return;
          }
        }

        // Replace preview with fresh content
        this.innerHTML = freshPreview.outerHTML;
        this.setAttribute('available', '');

        this.attachDrawer(section);
      }

      renderError() {
        if (!this.hasAttribute('available')) {
          this.innerHTML = '';
          return;
        }

        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        const button = this.querySelector('button');
        if (button) button.addEventListener('click', this.onClickRefreshList);
      }

      // ─── Drawer helpers ──────────────────────────────────────────

      attachDrawer(section) {
        const drawer = section?.querySelector('pickup-availability-drawer');
        if (!drawer) return;

        const existing = document.querySelector('pickup-availability-drawer');
        if (existing) existing.remove();

        document.body.appendChild(drawer);
      }

      removeDrawer() {
        const existing = document.querySelector('pickup-availability-drawer');
        if (existing) existing.remove();
      }

      // ─── Event handlers ──────────────────────────────────────────

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends BasicModal {
      constructor() {
        super();
      }
    }
  );
}